import React from 'react';
import styled from "styled-components";
import {array_unique} from "@helpers/arrays";
import Icon from "@atoms/icon";
import CloseIcon from "@icons/close.svg";
import ButtonTransparent from "../../../atoms/button.transparent";

const DropdownSelectedItems = ({topItems, setTopItems, handleItems}) => {

    const handleClick = (value) => {
        let selectedItems =  [...topItems];

        if (selectedItems.length) {
            for (let key in selectedItems) {
                const item = selectedItems[key];

                if (item && typeof item.value !== "undefined" && item.value === value) {
                    delete selectedItems[key];
                }
            }
        }

        selectedItems = array_unique(selectedItems);
        setTopItems(selectedItems);
        handleItems(value)
    };

    return (
        <Container className="d-flex align-items-center pb-8 mb-8">

            {
                (typeof topItems !== "undefined" && topItems.length) ?
                    topItems.map((item, key) =>
                        <Label key={key} className="position-relative d-flex align-items-center ml-8">
                            <span className="line-height-1">{item.label}</span>

                            <ClearButton className="rounded-circle d-block" onClick={() => handleClick(item.value)}>
                                <Icon width={7} height={7}>
                                    <CloseIcon/>
                                </Icon>
                            </ClearButton>
                        </Label>
                    )
                    : ''
            }

        </Container>
    );
};

export default React.memo(DropdownSelectedItems);

// styles

export const Container = styled.div`
    min-width: 100%;
    text-align: right;
    list-style: none;
    margin: 0;
    overflow-y: hidden;
    overflow-x: auto;
   
`;

const Label = styled.div`
    height: 32px;
    min-width: fit-content;
    border: 1.5px solid #160647;
    background-color: #ebf7ff;
    cursor: pointer;
    border-radius: 50px;
    padding: 8px 16px 8px 40px;
    
    .line-height-1 {
        line-height: 1;
    }
    
    &:first-child {
        margin-right: 24px;
    }
    
    &:last-child {
        margin-left: 24px;
    }
`;

const ClearButton = styled(ButtonTransparent)`
    display: none;
    position: absolute;
    background-color: ${props => props.theme.primary};
    width: 19px;
    min-width: 19px;
    height: 19px;
    min-height: 19px;
    left: 7px;
    top: 50%;
    outline: 0;
    line-height: 0;
    border: 0;
    justify-content: center;
    transform: translate(0, -50%);
    
    svg {
        g,path {
            stroke: #ffffff;
            stroke-width: 2.2px;
        }
    }
`;